import { VerifyPage } from "eri";

export default function Verify() {
  return <VerifyPage appName="MoodTracker" />;
}
